module.exports = __webpack_public_path__ + "assets/img/11-s.1a27a00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/11-s.jpg
// module id = lns+
// module chunks = 0